import * as React from "react";
const SvgRewind20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M.333 10 11 18v-6.75L20 18V2l-9 6.75V2L.333 10ZM9 6v8l-5.333-4L9 6Zm3.667 4L18 6v8l-5.333-4Z",
      clipRule: "evenodd"
    })
  );
export default SvgRewind20Px;
